import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.99 18.998c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1"
    />
    <path
      fill="currentColor"
      d="m29.58 23.498-11-19a2.95 2.95 0 0 0-1.09-1.1c-.91-.53-2.09-.53-3 0-.45.26-.83.64-1.09 1.1l-11 19a3 3 0 0 0 0 3c.26.46.64.84 1.09 1.1.46.26.97.4 1.5.41h22c.52 0 1.04-.14 1.5-.41.45-.26.83-.64 1.09-1.1s.4-.97.4-1.5-.14-1.04-.4-1.5m-1.73 2a.993.993 0 0 1-.86.51h-22c-.17 0-.35-.05-.5-.14a.9.9 0 0 1-.36-.37.96.96 0 0 1-.13-.5c0-.18.05-.35.13-.5l11-19c.09-.15.21-.28.36-.37s.32-.13.5-.13.34.05.5.13c.15.09.27.21.36.37l11 19c.09.15.13.32.13.5s-.05.35-.13.5"
    />
    <path
      fill="currentColor"
      d="M15.99 23.998a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
const SvgIconWarning = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWarning);
export default Memo;
